import React, { useEffect, useState, PureComponent } from "react";
import NavBar from "../../components/Navbar/Navbar";
// import isAccessTokenGeldig from "../../utils/auth";
// import axiosInstance from "../../utils/axiosApi";
import { useKeycloak } from "@react-keycloak/web";
import background_saved_image from './rvb_background.png';


const Home = () => {


  const [currentUser, setCurrentUser] = useState({
    username: "",
    groups: [],
    first_name: "",
    last_name: "",
    email: "",
    last_login: "",
  });

  const { keycloak, initialized } = useKeycloak();

  if (!!keycloak.authenticated){
    localStorage.setItem("access_token", keycloak.token)
    console.log("user is authenticated, setting the access token");
  };
  if (!keycloak.authenticated){
    console.log("user is NOT authenticated, setting null token in local storage");
  };
  // const username = localStorage.getItem("current_user");
  const username = localStorage.getItem("username");

  const retrieveCurrentUser = async () => {
   
    if (username === null) {
      console.log("forced to be here")
    }

    try {
      // await axiosInstance.get(`users/${username}`).then((response) => {
      //   setCurrentUser(response.data);

      //   // Sla user op in lokale opslag
      //   localStorage.setItem(
      //     "current_user_data",
      //     JSON.stringify(response.data)
      //   );
      // });
      console.log("forced to be here2")
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    // isAccessTokenGeldig();
    retrieveCurrentUser();
  }, []);

  return (
    <>
      <NavBar />
      {/* <div className="hidden xl:flex items-center space-x-5">
    <div className="hover:text-gray-200">
    </div>
    </div> */}
 


    <div>
                
      <hr />
          <div
              style={{
                  backgroundImage: `url(${background_saved_image})`,backgroundSize: 'cover' , backgroundRepeat: 'no-repeat', width: '100%', height: '950px', color: 'blue'
              }}>

              <div className="container has-text-centered">
                  <h1 className="title is-1" style={{ marginBottom: "2rem" }}>
                    <strong> {!!keycloak.authenticated && (<strong>Welcome ({keycloak.tokenParsed.preferred_username})</strong>)}</strong>
                  </h1>
                  <h2 className="subtitle is-4" style={{color: 'black'}}>
                    Pand Onderhoud Systeem 
                    <br></br>
                    {!keycloak.authenticated &&(<h3 style={{color: 'black'}}>Please click login button to, authenticate with keycloak to view the resources</h3>)}
                  </h2>
              </div>
          </div>
    </div>
   


      {/* <section className="hero is-light is-fullheight">
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title is-1" style={{ marginBottom: "2rem" }}>
              <strong>
              {!!keycloak.authenticated && (<strong>Welcome ({keycloak.tokenParsed.preferred_username})</strong>)}
              </strong>
            </h1>
            <h2 className="subtitle is-4">
              Pand Onderhoud Systeem (<strong>v0.1</strong>)
              <br></br>
              {!keycloak.authenticated &&(<h3>Please click login button to, authenticate with keycloak to view the resources</h3>)}
            </h2>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default Home;
